import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { AppContext } from "core/context";

const SelfServiceHeader = observer(() => {
  const appContext = useContext(AppContext);

  if (!appContext.header) {
    return null;
  }

  return (
    <h1 className="main-heading">
      {appContext.header}
    </h1>
  );
});

export default SelfServiceHeader;
